import { type ReactNode } from 'react';
import { Topbar } from './Topbar';
import { GlobalUpgradeModal } from '@/features/billing/components/GlobalUpgradeModal';

interface AppLayoutProps {
  topbarChildren?: ReactNode;
  children: ReactNode;
}

export function AppLayout({ topbarChildren, children }: AppLayoutProps) {
  return (
    <div className="flex h-screen flex-col bg-clyra-bg [body.paper_&]:bg-paper">
      <Topbar>{topbarChildren}</Topbar>
      <div className="flex flex-1 overflow-hidden">{children}</div>
      <GlobalUpgradeModal />
    </div>
  );
}
